<div #modal role="dialog" aria-modal="true" i18n-aria-label aria-label="modal">
  <div class="backdrop" animate.enter="backdrop-enter" (click)="cancel()" (keypress)="cancel()" tabindex="0"></div>
  <div
    class="modal"
    [ngClass]="animation"
    [class.modal-tada-enter]="animation === 'tada'"
    [class.modal-slide-in-enter]="animation === 'slideInOut'"
  >
    @if (cancellable) {
      <div class="close" (click)="cancel()" (keypress)="cancel()" tabindex="0">
        <img src="icons/close.svg" i18n-alt alt="close" />
      </div>
    }
    <ng-template #modalContent></ng-template>
  </div>
</div>
